// A user's permissions and the role they come from.
//
// users/{uid} holds:
//   role                  'manager' | ...
//   permissions           the list the app and the database rules check at runtime
//   permission_overrides  { add: [...], remove: [...] } - LEGACY per-user differences from the role
//
// The role is the only source of a user's permissions (owner, 24 Sep 2026): User Management
// saves exactly the role's list, and Role Management pushes exactly the role's list to every
// user of the role and clears any old overrides (audit ADM-07, 26 Sep 2026 - before, the push
// re-applied them, so a legacy exception survived every role change).

/** What a profile holds: its own list; no list = nothing (never the role's defaults - audit ADM-12,
 * the rules refuse such a profile everything, so the menu must not show it modules either). */
export const profilePermissions = (userData) => (Array.isArray(userData && userData.permissions) ? userData.permissions : []);

/** The fields a role save writes onto one user of that role, or null when the user's role no longer exists. */
export const rolePushFor = (roles, userData) => {
  const role = userData && userData.role;
  if (!role || !roles || !roles[role]) return null;
  return { permissions: [...(roles[role].permissions || [])], permission_overrides: { add: [], remove: [] } };
};

export const effectivePermissions = (rolePermissions, overrides) => {
  const add = (overrides && overrides.add) || [];
  const remove = new Set((overrides && overrides.remove) || []);
  const out = new Set([...(rolePermissions || []), ...add]);
  remove.forEach((p) => out.delete(p));
  return [...out];
};

// The overrides that turn `rolePermissions` into `selected` (what the admin ticked).
export const overridesFor = (rolePermissions, selected) => {
  const role = new Set(rolePermissions || []);
  const sel = new Set(selected || []);
  return {
    add: [...sel].filter((p) => !role.has(p)),
    remove: [...role].filter((p) => !sel.has(p)),
  };
};
